import {ThemeIconKey, ThemeColorPath, Box, Icon, ThemeLottieKey, Lottie} from 'platform/foundation';
import {useTheme} from 'styled-components';

interface IconOrLottieProps {
  value: ThemeIconKey | ThemeLottieKey;
  color?: ThemeColorPath;
}

export function IconOrLottie({value, color}: IconOrLottieProps) {
  const theme = useTheme();

  const isLottie = !(value in (theme.icons || {}));

  if (isLottie) {
    return (
      <Box width={4} height={4}>
        <Lottie value={value as ThemeLottieKey} minHeight={4} autoplay loop />
      </Box>
    );
  }

  return <Icon size={4} value={value as ThemeIconKey} color={color} />;
}
